import { AppViewIds } from './appViewIds';

/**
 * Check whether the current user can access an AppView.
 * @param {string} appViewId - Guid string from AppViewIds
 * @param {object} permissionState - from Zustand usePermissionState()
 * @returns {boolean}
 */
export function canAccess(appViewId, permissionState) {
    if (!appViewId || !permissionState?.appViewIds) {
        return false;
    }

    const normalizedId = appViewId.toLowerCase();
    return permissionState.appViewIds.some(
        (id) => id.toLowerCase() === normalizedId
    );
}

export function canAccessAny(appViewIds, permissionState) {
    return appViewIds.some((id) => canAccess(id, permissionState));
}

/** Route shells inferred from tab grants — excluded from the permission matrix. */
export const INFERRED_PAGE_SHELL_APP_VIEW_IDS = [
    AppViewIds.Surveys,
    AppViewIds.Account,
];

/** Tab grants that imply access to /surveys (parent Surveys AppView is not granted). */
export const SURVEYS_TAB_APP_VIEW_IDS = [
    AppViewIds.SurveysReceived,
    AppViewIds.SurveysSent,
];

/** Tab grants that imply access to /account (parent Account AppView is not granted). */
export const ACCOUNT_TAB_APP_VIEW_IDS = [
    AppViewIds.AccountUserInfo,
    AppViewIds.AccountCompany,
    AppViewIds.AccountEmployees,
    AppViewIds.AccountPriceOptions,
    AppViewIds.AccountLicenses,
    AppViewIds.AccountRulers,
];

/**
 * Nav and route checks for registry entries. Parent page shells (Surveys, Account)
 * are inferred from their tab grants.
 */
export function canAccessNavItem(appViewId, permissionState) {
    if (appViewId === AppViewIds.Surveys) {
        return canAccessAny(SURVEYS_TAB_APP_VIEW_IDS, permissionState);
    }

    if (appViewId === AppViewIds.Account) {
        return canAccessAny(ACCOUNT_TAB_APP_VIEW_IDS, permissionState);
    }

    return canAccess(appViewId, permissionState);
}
